export default __webpack_public_path__ + "static/media/lista-de-verificacion.c20cfe3f.png";